import { Timeschedule } from "../../../../../store/api/TimescheduleApi";
import ModelInstance from "../ModelInstance";
import { Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";

export function TimescheduleLeaf<P extends Timeschedule>({
  timeschedule,
  editable = false,
  onClick,
}: {
  timeschedule: P | null;
  editable?: boolean;
  onClick?: (timeschedule: P | null) => void;
}) {
  const model =
    timeschedule == null ? (
      "all opening hours"
    ) : (
      <ModelInstance instance={timeschedule} mark={"none"} modelName={"Timeschedule"} />
    );

  return (
    <Tooltip title={editable ? "Click to edit" : undefined}>
      Active during{" "}
      <Box
        component={"span"}
        onClick={() => {
          onClick?.(timeschedule);
        }}
        sx={
          editable
            ? {
                textDecoration: "underline dotted",
                "&:hover": { cursor: "pointer" },
              }
            : {}
        }
      >
        {model}
      </Box>
    </Tooltip>
  );
}
